/**
 * Shared helper to determine whether a user profile is "complete" for auth flows.
 * Used by both web and mobile to decide whether to route users to signup-details.
 */
export function isProfileComplete(profile, options = { requirePhoneVerified: true }) {
    if (!profile)
        return false;
    const requirePhoneVerified = options.requirePhoneVerified ?? true;
    const firstNameOk = typeof profile.firstName === 'string' && profile.firstName.trim().length > 0;
    const lastNameOk = typeof profile.lastName === 'string' && profile.lastName.trim().length > 0;
    const phoneOk = typeof profile.phone === 'string' && profile.phone.trim().length > 0;
    if (!firstNameOk || !lastNameOk || !phoneOk)
        return false;
    if (!requirePhoneVerified)
        return true;
    return profile.isPhoneVerified === true;
}
